import React from 'react';
import Logo from '../Logo';

/**
 * Footer branding section with logo, tagline, and copyright.
 */
const FooterInfo: React.FC = () => {
  return (
    <div className="space-y-4">
      <Logo size="sm" />
      <p className="text-muted-foreground text-sm max-w-xs leading-relaxed">
        Free, beautifully designed calculators for finance, health, education, and everyday life. No sign-up required.
      </p>
      <p className="text-muted-foreground/60 text-xs">
        © {new Date().getFullYear()} GetCalculator. All rights reserved.
      </p>
    </div>
  );
};

export default FooterInfo;
